import React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    Avatar,
    Menu,
    MenuItem
} from '@mui/material';
import {
    Menu as MenuIcon,
    ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon,
    AccountCircle,
    Logout
} from '@mui/icons-material';

const TopAppBar = ({ onMobileMenuToggle, onToggleSidebar, sidebarCollapsed }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleUserMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleUserMenuClose();
        // Add your logout logic here
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                width: { md: `calc(100% - ${sidebarCollapsed ? '80px' : '280px'})` },
                ml: { md: `${sidebarCollapsed ? '80px' : '280px'}` },
                background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                boxShadow: '0 3px 5px 2px rgba(102, 126, 234, .3)',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                transition: (theme) => theme.transitions.create(['width', 'margin'], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            }}
        >
            <Toolbar>
                {/* Mobile menu button */}
                <IconButton
                    color="inherit"
                    edge="start"
                    onClick={onMobileMenuToggle}
                    sx={{ mr: 2, display: { md: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>

                {/* Desktop toggle button */}
                <IconButton
                    color="inherit"
                    onClick={onToggleSidebar}
                    sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
                >
                    {sidebarCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>

                {/* Page title */}
                <Typography 
                    variant="h6" 
                    noWrap 
                    component="div"
                    sx={{ 
                        flexGrow: 1,
                        fontWeight: 'bold'
                    }}
                >
                    University Management System
                </Typography>

                {/* User profile section - positioned at extreme right */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            cursor: 'pointer',
                            p: 1,
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                            }
                        }}
                        onClick={handleUserMenuOpen}
                    >
                        <Avatar sx={{ width: 32, height: 32, bgcolor: 'rgba(255, 255, 255, 0.2)', mr: 1 }}>
                            <AccountCircle />
                        </Avatar>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', display: { xs: 'none', sm: 'block' } }}>
                            Admin Admin
                        </Typography>
                    </Box>
                    
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleUserMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem onClick={handleUserMenuClose}>
                            <AccountCircle sx={{ mr: 2 }} />
                            Profile Settings
                        </MenuItem>
                        <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
                            <Logout sx={{ mr: 2 }} />
                            Logout
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopAppBar;